import React, { Fragment } from 'react'
import { Timeline, Typography } from 'antd'
import { get, map } from 'lodash'

import { formatCreatedByText } from '../utils'

import eventDifference from './event-difference'
import getEventDifferenceText from './get-event-difference-text'

const renderSimpleUpdateEvent = (event, nameProp, omitProps) => {
  const { original, changes, createdAt, createdBy } = event

  const eventDifferences = eventDifference(
    original,
    changes,
    nameProp,
    omitProps,
  )

  return (
    <Timeline.Item key={event.id}>
      <Typography.Text>Updated {get(original, nameProp)}:</Typography.Text>
      <br />
      {map(eventDifferences, ({ differentKey, original, change }) => (
        <Fragment key={differentKey}>
          <Typography.Text>
            {getEventDifferenceText(differentKey, original, change)}
          </Typography.Text>
          <br />
        </Fragment>
      ))}
      <Typography.Text>
        {formatCreatedByText(createdAt, createdBy.name)}
      </Typography.Text>
    </Timeline.Item>
  )
}

export default renderSimpleUpdateEvent
